import { render, staticRenderFns } from "./v-image-group.vue?vue&type=template&id=28c8ad5c&scoped=true&"
import script from "./v-image-group.vue?vue&type=script&lang=js&"
export * from "./v-image-group.vue?vue&type=script&lang=js&"
import style0 from "./v-image-group.vue?vue&type=style&index=0&id=28c8ad5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8ad5c",
  null
  
)

export default component.exports